<template>
  <div class="intro-wrapper ds-flex center-center">
    <div class="greeting-box ds-flex">
      <img src="@/assets/about/CEO_new_img_pc.svg" class="pc"/>
      <div class="greeting-banner mobile ds-flex center-between">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="214" height="109" viewBox="0 0 214 109">
            <defs>
              <clipPath id="clip-path">
                <rect id="사각형_50" data-name="사각형 50" width="35" height="30" fill="none"/>
              </clipPath>
            </defs>
            <g id="text" transform="translate(-80 -283)">
              <text id="지오비전이_보다_안전한_일상을_위해_여러분_곁으로_더_가까이_다가갑니다." data-name="지오비전이
          보다 안전한 일상을 위해
          여러분 곁으로 더 가까이 다가갑니다." transform="translate(80 297)" fill="#1e1e1e" font-size="15" font-family="Pretendard-Medium, Pretendard" font-weight="500"><tspan x="0" y="0">지오비전이</tspan><tspan fill="#00aceb" font-size="19" font-family="Pretendard-Bold, Pretendard" font-weight="700"><tspan x="0" y="26">보다 안전한 일상을</tspan><tspan y="26" fill="#1e1e1e" font-size="15"> </tspan><tspan y="26" fill="#1e1e1e" font-size="15" font-family="Pretendard-Medium, Pretendard" font-weight="500">위해</tspan></tspan><tspan x="0" y="52">여러분 곁으로 더 가까이 다가갑니다.</tspan></text>
              <text id="지오비전_CEO_김_윤" data-name="지오비전 CEO   김 윤" transform="translate(80 389)" fill="#1e1e1e" font-size="10" font-family="Pretendard-Regular, Pretendard"><tspan x="0" y="0" xml:space="preserve">지오비전 CEO   </tspan><tspan y="0" font-size="14" font-family="Pretendard-Bold, Pretendard" font-weight="700">김 윤</tspan></text>
              <g id="대표님_싸인" transform="translate(186.591 361.836)">
                <g id="그룹_481" data-name="그룹 481" transform="translate(0.409 0.164)" clip-path="url(#clip-path)">
                  <path id="패스_7" data-name="패스 7" d="M2.7,29.781A2.931,2.931,0,0,1,.576,28.558a2.077,2.077,0,0,1-.558-1.677c.232-1.742,2.694-3.391,4.866-4.845a19.413,19.413,0,0,0,2.444-1.8c.062-.061.128-.126.2-.194,1-3.059,2.108-6.427,2.883-8.7a6.793,6.793,0,0,1-.839.75,2.606,2.606,0,0,1-2.058.6,1.765,1.765,0,0,1-1.116-1.076c-.289-.638-.624-.988-.995-1.039-.453-.061-1.018.306-1.679,1.1-.585.7-1.881,2.782-1.895,2.8a.2.2,0,0,1-.284.066.209.209,0,0,1-.066-.286C1.529,14.161,2.8,12.119,3.4,11.4c.769-.918,1.442-1.324,2.051-1.24.52.071.962.5,1.314,1.278a1.376,1.376,0,0,0,.848.847,2.3,2.3,0,0,0,1.711-.535,9.534,9.534,0,0,0,1.415-1.389c.3-.862.516-1.456.611-1.654l.019-.039c.573-1.192.584-1.214.815-1.45a.617.617,0,0,1,.8-.089c.125.1.372.4-.031,1.06a28.235,28.235,0,0,1-1.85,2.386c-.712,2.059-1.88,5.6-2.929,8.8,1.25-1.293,2.97-3.162,4.41-4.726,1.208-1.313,2.162-2.35,2.491-2.669a4.668,4.668,0,0,0,.521-.705c.765-2.167,1.389-4.058,1.909-5.633C18.564,2.438,19.147.671,19.7.205c.361-.305.6-.2.718-.114.591.461.17,2.664-.586,4.251-.446.937-2.634,5.2-3.854,7.107-.638,1.8-1.374,3.8-2.229,5.963-2.007,5.075-3.1,8.038-3.683,9.713a45.182,45.182,0,0,1,5.47-7.42c2.83-3.057,3.414-3.11,3.739-2.919s.308.667-.02,1.723a18.786,18.786,0,0,1-2.987,5.049c-.168,1.216-.46,3.768-.114,4.759a.146.146,0,0,0,.029.057h.006c.3,0,1.347-1.45,1.974-2.319.208-.288.414-.575.614-.843.862-1.16,1.842-2.778,2.349-3.639a.274.274,0,0,1,.349-.113.27.27,0,0,1,.158.321c-.721,2.686-1.015,4.628-.768,5.068.05.089.086.108.092.108.222-.006.706-.976.938-1.442.146-.292.283-.568.407-.772.066-.107.144-.249.233-.409.6-1.081,1.152-1.966,1.739-1.882.336.049.573.4.727,1.08a12.561,12.561,0,0,1,.22,1.51c.043.42.107,1.054.223,1.114.017.005.207.014.9-.843.426-.526.791-1.032,1.083-1.438.644-.9.966-1.345,1.328-1.24.274.079.392.416.451,1.289.053.786.062,1.373.065,1.781.174-.35.424-.843.79-1.477.831-1.441,1.2-1.686,1.5-1.614.359.089.383.615.406,1.125l.006.116c.018.354.019.94.016,1.47,1.053-2.684,1.288-2.687,1.421-2.688a.249.249,0,0,1,.23.161l.015.09a7.646,7.646,0,0,0,.136,1.232c.168,1.048.509,1.869.7,1.9.02,0,.094-.03.206-.234a.206.206,0,0,1,.281-.081.208.208,0,0,1,.081.283c-.185.335-.4.485-.638.442-.666-.117-.983-1.892-1.04-2.247-.054-.337-.088-.6-.108-.792-.32.632-.858,1.945-1.314,3.164l-.4-.077c0-.019.038-1.867,0-2.6l-.006-.119a2.12,2.12,0,0,0-.112-.75c.007.015-.251.088-1.024,1.428-.4.7-.662,1.221-.835,1.569-.25.5-.317.639-.517.591s-.2-.2-.207-.782c0-.406-.008-1.019-.066-1.864a2.386,2.386,0,0,0-.155-.906,5.578,5.578,0,0,0-.876,1.073c-.3.411-.664.923-1.1,1.457-.648.8-1.023,1.073-1.34.979-.376-.113-.431-.653-.514-1.47a12.179,12.179,0,0,0-.211-1.46c-.153-.676-.332-.753-.383-.761-.359-.052-1.032,1.158-1.32,1.674-.092.165-.174.312-.242.423-.114.188-.249.456-.39.74-.5,1-.86,1.66-1.3,1.671-.121.012-.31-.049-.462-.319-.342-.609.028-2.6.489-4.456-.532.876-1.241,1.995-1.888,2.864-.2.266-.4.551-.611.838-1.145,1.587-1.869,2.554-2.385,2.481a.437.437,0,0,1-.347-.325,12.88,12.88,0,0,1,.013-4.333,4.89,4.89,0,0,1-2,1.468.233.233,0,0,1-.288-.13c-.177-.44,2.39-2.681,2.574-2.781l.244.175a17.425,17.425,0,0,0,2.553-4.468c.33-1.059.217-1.227.2-1.243-.071-.022-.581-.011-3.225,2.846a45.224,45.224,0,0,0-6.4,9.109l-.268.1-.129-.258c.113-.41.852-2.9,4.327-11.682.672-1.7,1.271-3.3,1.806-4.779-.437.453-1.3,1.393-2.28,2.455-1.681,1.827-3.744,4.069-5,5.332L7.332,21.96c-.974,2.977-1.529,4.67-1.606,4.856C5.389,27.622,4.45,29.521,3,29.757a1.862,1.862,0,0,1-.3.024m4.557-8.927c-.561.467-1.335.986-2.146,1.529-2,1.336-4.479,3-4.686,4.555a1.656,1.656,0,0,0,.46,1.348,2.337,2.337,0,0,0,2.044,1.062c1.283-.208,2.172-2.113,2.413-2.692.075-.18.779-2.332,1.594-4.825l.319-.976m8.621,2.475a20.669,20.669,0,0,0-1.574,1.551,7.914,7.914,0,0,0,1.565-1.486c0-.022.006-.044.009-.064M20.151.417a.375.375,0,0,0-.188.106c-.46.39-1.1,2.324-2.065,5.253-.36,1.091-.77,2.334-1.243,3.716,1.106-1.965,2.4-4.478,2.8-5.329.846-1.777.967-3.539.7-3.743a.019.019,0,0,0-.012,0M12.656,7.433a.253.253,0,0,0-.173.074c-.184.187-.184.187-.738,1.34l-.019.04c-.045.092-.119.281-.218.551.571-.718,1.018-1.34,1.1-1.468.186-.305.179-.476.128-.515a.123.123,0,0,0-.076-.022" transform="translate(-0.026 0.134)" fill="#1a1311"/>
                  <path id="패스_8" data-name="패스 8" d="M60.012,36.179a5.358,5.358,0,0,1,.323.569,4.439,4.439,0,0,1,.235.573.206.206,0,1,0,.4-.11,5.554,5.554,0,0,0-.6-1.242.209.209,0,0,0-.282-.074.212.212,0,0,0-.074.284" transform="translate(-35.245 -20.826)" fill="#1a1311"/>
                </g>
              </g>
            </g>
        </svg>
        <img src="@/assets/about/CEO_new_img_mobile.svg"/>
      </div>
      <div class="greeting-contents ds-flex">
        <div class="greeting">
          <h3 class="greeting-title">CEO 인사말</h3>
          <p class="pc">
            지금까지 어려운 환경에서도 임직원 모두가 한 방향으로 힘을 모아 높은 성과를 이끌어 내었으며,<br/>
            이제는 어떠한 환경에서도 신뢰를 바탕으로 지속 성장할 수 있는 기반을 갖추었습니다.<br/><br/>
            창의적인 인공지능(AI) 기술로 고객에게 차별화된 가치를 제공하고,<br/>
            기술진보 및 시장변화에 능동적으로 대응하여<br/>
            한층 높은 서비스 및 제품을 제공할 수 있도록 최선을 다하겠습니다.<br/><br/>
            앞으로도 많은 관심과 성원을 부탁 드립니다.<br/><br/>
            감사합니다.
          </p>
          <p class="mobile">
            지금까지 어려운 환경에서도 임직원 모두가 한 방향으로 힘을 모아 높은 성과를 이끌어 내었으며, 이제는 어떠한 환경에서도 신뢰를 바탕으로 지속 성장할 수 있는 기반을 갖추었습니다.<br/><br/>
            창의적인 인공지능(AI) 기술로 고객에게 차별화된 가치를 제공하고, 기술진보 및 시장변화에 능동적으로 대응하여 한층 높은 서비스 및 제품을 제공할 수 있도록 최선을 다하겠습니다.<br/><br/>
            앞으로도 많은 관심과 성원을 부탁 드립니다.<br/><br/>
            감사합니다.
          </p>
        </div>
        <div class="career">
          <h3 class="greeting-title">CEO 주요 경력</h3>
          <div class="ds-flex start-start pc">
            <p>
              · 현) 강원대학교 컴퓨터공학과 교수<br/>
              · 전) 강원대학교 IT대학 부학장<br/>
              · 전) 강원특별자치도 과학기술위원<br/>
              · 전) LG전자 연구원<br/>
              · 고려대학교 학/석/박사
            </p>
            <p>
              · 중소기업벤처부장관상<br/>
              · 강원특별자치도지사표창<br/>
              · 춘천시장표창
            </p>
          </div>
          <div class="mobile">
            <p>· 현) 강원대학교 컴퓨터공학과 교수</p>
            <p>· 중소기업벤처부장관상</p>
            <p>· 전) 강원대학교 IT대학 부학장</p>
            <p>· 강원특별자치도지사표창</p>
            <p>· 전) 강원특별자치도 과학기술위원</p>
            <p>· 춘천시장표창</p>
            <p>· 전) LG전자 연구원</p>
            <p></p>
            <p>· 고려대학교 학/석/박사</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Introduction',
  components: {
    
  },
  data: () => ({
  }),
  methods: {
    onClickHighlightBtn() {
      this.highlight.active = !this.highlight.active;

      if(this.highlight.active) {
        this.highlight.style = {'-webkit-transform' : 'translateX(38px)'};
      } else {
        this.highlight.style = {'-webkit-transform' : 'translateX(0px)'}
      }
    }
  },
}
</script>

<style scoped>
.intro-wrapper {
  padding: 80px 0;
  color: #191E2C;
  border-top: 1.5px solid #00ACEB;
}

.greeting-box {
  width: 1240px;
}

.greeting-contents {
  width: 665px;
  align-content: center;
}

.greeting-title {
  color: #1E1E1E;
  font-size: 22px;
  text-align: left;
  font-weight: bold;
  padding-bottom: 20px;
}

.greeting {
  padding: 0 0 40px 20px;
  margin-left: 25px;
  width: 100%;
  border-bottom: 1px solid #DBDEE7;
}

.career {
  padding: 40px 0 40px 20px;
  margin-left: 25px;
  width: 100%;
}

.greeting p, .career p {
  color: #505050;
  font-size: 16px;
  text-align: left;
}

.career p {
  line-height: 40px;
}

.career p:first-child {
  margin-right: 80px;
}

.intro-wrapper .title-box h1 {
  font-size: 50px;
  font-weight: bold;
  padding-right: 24px;
  padding-left: 0;
}

.intro-wrapper .title-box p {
  font-size: 20px;
  font-weight: bold;
}

.greeting-box .sign-box {
  width: 100%;
  padding-top: 60px;
  position: relative;
}

.greeting-box .sign-box h2 {
  font-size: 32px;
  font-weight: bold;
  text-align: right;
}

.greeting-box .sign-box img {
  position: absolute;
  right: 145px;
  top: -100px;
}

.highlight-box {
  border: 1px solid #DDDDDD;
  border-radius: 99px;
  padding: 13px 34px 14px 34px;
  width: 496px;
  height: 70px;
  box-sizing: border-box;
}

.highlight-box img {
  width: 30px;
  height: 35px;
}

.highlight-box p {
  color: #191E2C;
  font-size: 20px;
  font-weight: bold;
}

.highlight-active-box {
  background-color: #DDDDDD;
  width: 80px;
  height: 40px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  padding: 5px;
  box-sizing: border-box;
  transition: .5s;
  cursor: pointer;
}

.highlight-active-box.active {
  background-color: #00ACEB;
}

.highlight-active-btn {
  background-color: #fff;
  box-shadow: 0px 3px 6px #00000029;  
  width: 32px;
  height: 32px;
  border-radius: 100%;
  transition: .5s;
}

.history-list-box {
  width: 100%;
  padding: 80px 0;
}

.history-list-box .year-box {
  position: relative;
  width: 20%;
  color: #191E2C;
  font-size: 50px;
  text-align: left;
  font-weight: bold;  
}

.history-list-box .year-box .now-box {
  position: absolute;
  width: 100px;
  height: 21px;
  background-color: #00ACEB;
  z-index: -1;
  top: 35px;
  left: 20px;
}

.history-list-box .year-box .now-box > p {
  position: absolute;
  font-size: 20px;
  right: 1px;
  top: 20px;
  font-weight: bold;
}

.history-list-box .list-box {
  width: 80%;
}

.history-list-box .list-box div {
  width: 100%;
  color: #505050;
  text-align: left;
  font-size: 20px;
  padding-bottom: 20px;
}

.history-list-box .list-box .deco {
  text-decoration: underline;
  font-weight: bold;
  color: #191E2C;
}

.history-list {
  padding-top: 80px;
}

.mobile {
  display: none;
}

@media screen and (max-width: 1240px) {
  .intro-wrapper {
    padding: 40px 0;
    min-height: calc(100vh - 632px);
  }

  .greeting-box {
    width: 768px;
  }

  .greeting-box > img {
    width: 301px;
    height: 422px;
  }

  .greeting-title {
    font-size: 18px;
    line-height: 20px;
    padding-bottom: 15px;
  }

  .greeting p, .career p {
    font-size: 11px;
    line-height: 20px;
  }

  .career p:first-child {
    margin-right: 60px;
  }

  .greeting-contents {
    width: 444px;
  }

  .greeting {
    padding: 20px 0;
    margin-left: 25px;
  }

  .career {
    padding: 20px 0;
    margin-left: 25px;
  }
}

@media screen and (max-width: 768px) {
  .intro-wrapper {
    padding: 0px 40px;
    border-top: none;
    min-height: calc(100vh - 520px);
  }

  .pc {
    display: none;
  }

  .mobile {
    display: inline-block;
  }

  .greeting-contents {
    width: 100%;
  }

  .greeting {
    margin-left: 0;
    padding: 16px 0 20px 0;
  }

  .career {
    margin-left: 0;
    padding: 20px 0 30px 0;
  }

  .greeting p, .career p {
    font-size: 12px;
  }

  .career .mobile {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .career .mobile > p {
    width: 220px;
    margin-right: 0;
    line-height: 25px;
  }

  .greeting-banner {
    width: 100%;
    height: 160px;
    background-color: #F4F5F7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px 0 40px;
    position: relative;
  }

  .greeting-banner > img {
    position: absolute;
    right: 10px;
    bottom: 0;
  }
}

@media screen and (max-width: 480px) {
  .intro-wrapper {
    padding: 0;
  }

  .greeting-contents {
    padding: 0 60px;
  }

  .greeting, .career {
    padding: 30px 0;
  }

  .greeting-title {
    font-size: 20px;
  }

  .greeting p, .career p {
    font-size: 16px;
    line-height: 25px;
  }

  .career .mobile > p {
    line-height: 33px;
  }

}
</style>
